import { render, staticRenderFns } from "./ChannelsAdd.vue?vue&type=template&id=75561b52&"
import script from "./ChannelsAdd.vue?vue&type=script&lang=js&"
export * from "./ChannelsAdd.vue?vue&type=script&lang=js&"
import style0 from "./ChannelsAdd.vue?vue&type=style&index=0&id=75561b52&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports